import Vue from 'vue'
import vShortKey from 'vue-shortkey'

Vue.use(vShortKey, { prevent: ['.prevent-short-key', 'textarea'] })
